import { SvgIcon } from '@material-ui/core';
import React from 'react';
import theme from 'theme';

const Wallet = (props) => (
  <SvgIcon viewBox="0 0 24 24" width="20" height="20" {...props}>
    <path
      d="M21 7.28V5c0-1.1-.9-2-2-2H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-2.28c.59-.35 1-.98 1-1.72V9c0-.74-.41-1.37-1-1.72M20 9v6h-7V9zM5 19V5h14v2h-6c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h6v2z"
      fill={theme.palette.primary.main}
    ></path>
    <circle cx="16" cy="12" r="1.5" fill={theme.palette.primary.main}></circle>
  </SvgIcon>
);

Wallet.displayName = 'WalletIcon';
Wallet.muiName = 'SvgIcon';

export default Wallet;
